module.exports = __webpack_public_path__ + "img/address-with-magnifier-circle-transparent100x100.118b174d.png";